export default {
	data() {
		return {
			isTransitioning: false,
		};
	},
	computed: {
		view() {
			return this.$router.currentRoute.name;
		},
		transitionName() {
			let transitionName = "";

			switch (this.view) {
			default:
				transitionName = "fade";
				break;
			}

			return transitionName;
		},
		transitionMode() {
			let transitionMode = "";

			switch (this.view) {
			default:
				transitionMode = "";
				break;
			}

			return transitionMode;
		},
	},
};
